module.exports = __webpack_public_path__ + "img/touxiang.cf04fb5a.jpg";